module.exports = __webpack_public_path__ + "img/blogs_muted_amber.6c0e5984.png";